import ES6Promise from "es6-promise";
import {
  initWMDASDK,
  sendWMDAShow,
  domClickStatistics_wmda,
  sendClickStatistics_wmda,
  aClickStatistics_wmda
} from "newcar-ui/output/cjs/utils/wmdaTracklog.js";
if (!window.Promise) {
  ES6Promise.polyfill();
}
if (typeof window != "undefined") {
  initWMDASDK().then(() => {
    sendWMDAShow();
    aClickStatistics_wmda();
    // 绑定特定元素 domClickStatistics_wmda（class类名||id||dom）
    window.domClickStatistics_wmda = domClickStatistics_wmda;
    // 手动触发埋点 sendClickStatistics_wmda（eventId,{...otherData}）
    window.sendClickStatistics_wmda = sendClickStatistics_wmda;
    // 针对前后端未分离的旧项目 需要添加wmda展现埋点的 采用页面添加id为wmdaPageShowLog的a标签
    let wmdaPageShowLogDom = document.getElementById("wmdaPageShowLog");
    if (wmdaPageShowLogDom && wmdaPageShowLogDom.getAttribute("data-wmda-eventid") && wmdaPageShowLogDom.getAttribute("data-wmda-pagetype") && wmdaPageShowLogDom.getAttribute("data-wmda-page")) {
      wmdaPageShowLogDom.setAttribute("data-wmda-actiontype", "show");
      wmdaPageShowLogDom.click();
    }
  });
}
